<template>
  <div class="login-container">
    <img class="login-bg" src="@/assets/login/bg.jpg" />
    <div class="login-logo">
      <img class="login-logo-img" src="@/assets/login/logo.png" />
      <span>药事服务系统</span>
    </div>
    <div class="login-wd" @click="handleClickWd">
      <img class="login-wd-img" src="@/assets/login/wd.png" />
      <span>系统介绍</span>
    </div>
    <div v-if="!isScanCode" class="login-code-box" v-loading="loading">
      <div class="login-code-box-title">
        <img class="login-code-box-title-img" src="@/assets/login/logo-2.png" />
        <span>欢迎登录</span>
      </div>
      <div class="login-code-box-img-box" v-if="isExpired === 0">
        <img class="login-code-img" :src="codeUrl" />
      </div>
      <div class="login-code-is-scan" v-if="isExpired === 1">
        <img class="login-code-is-scan-img" :src="codeUrl" />
        <i class="el-icon-success login-code-is-scan-icon"></i>
        <div class="login-code-is-scan-text">扫码成功</div>
      </div>
      <div v-if="isExpired === 2" class="login-code-expired">
        <img class="login-code-expired-img" :src="codeUrl" />
        <div class="login-code-expired-text">已失效</div>
        <div class="login-code-expired-code" @click="fetchData">刷新二维码</div>
      </div>
      <div class="login-code-text">
        <div v-if="isExpired === 0 || isExpired === 2">
          微信扫一扫，选择该微信下的机构账号一键登录
        </div>
        <div v-if="isExpired === 1">
          <div>请在微信中选择机构</div>
          <div>一键登录</div>
        </div>
      </div>
      <div class="login-code-re-scan" @click="fetchData" v-if="isExpired === 1">
        重新扫码
      </div>
      <!-- <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 10px;
        "
      >
        <el-button type="primary" size="mini" @click="handleLoginTest(1)"
          >连锁总部1</el-button
        >
        <el-button type="primary" size="mini" @click="handleLoginTest(2)"
          >连锁总部2</el-button
        >
        <el-button type="primary" size="mini" @click="handleLoginTest(0)"
          >连锁门店</el-button
        >
      </div> -->
    </div>
    <div v-if="isScanCode" class="login-info-box" v-loading="loginLoading">
      <div class="login-info-box-title">
        <img class="login-info-box-title-img" src="@/assets/login/logo-2.png" />
        <span>欢迎登录</span>
      </div>
      <div class="login-info-text-box">
        <div class="login-info-text">
          <div class="login-info-text-title">当前机构</div>
          <div>：</div>
          <div class="login-info-text-value">
            {{ enterpriseName }}
          </div>
        </div>
        <div class="login-info-text">
          <div class="login-info-text-title">登录用户</div>
          <div>：</div>
          <div class="login-info-text-value">{{ userName }}</div>
        </div>
        <div class="login-info-text">
          <div class="login-info-text-title">手机号</div>
          <div>：</div>
          <div class="login-info-text-value">{{ userPhone }}</div>
        </div>
        <div class="login-info-text">
          <div class="login-info-text-title">岗位</div>
          <div>：</div>
          <div class="login-info-text-value">{{ userStationStr }}</div>
        </div>
      </div>
      <div class="login-info-button-box">
        <div
          :class="['login-info-button-primary', { info: btnType == 0 }]"
          style="width: 100%"
          @click="handleLogin"
        >
          <div class="login-info-button-text">{{ btnText }}</div>
          <div class="login-info-button-sub-text">
            {{ btnTextSub }}
          </div>
        </div>
        <div class="login-info-button" @click="handlePurchase">
          <span>开通正式版</span>
          <i class="el-icon-d-arrow-right" />
        </div>
      </div>
    </div>

    <div class="login-footer">
      <div>北京众力合创信息技术有限公司</div>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="__blank">
        京ICP备2026022938号-1
      </a>
      <div>
        药品医疗器械网络信息服务备案：（京）网药械信息备字（2026）第00120号
      </div>
    </div>

    <Purchase ref="PurchaseRef" @successPay="handleLogin" />
  </div>
</template>

<script>
import Purchase from "@/components/Purchase";
import { getToken as getAuthToken } from "@/utils/auth";
export default {
  name: "Login",
  components: { Purchase },
  data() {
    return {
      codeUrl: "",
      isScanCode: false,
      isExpired: 0,
      timer: null,
      enterpriseName: "",
      userName: "",
      userPhone: "",
      userStationStr: "",
      btnText: "",
      btnTextSub: "",
      btnType: 0,
      icon: "",
      enterpriseId: "",
      openId: "",
      loading: false,
      loginLoading: false,
    };
  },
  watch: {
    // $route: {
    //   handler: function (route) {
    //     const query = route.query;
    //     if (query) {
    //       this.redirect = query.redirect;
    //       this.otherQuery = this.getOtherQuery(query);
    //     }
    //   },
    //   immediate: true,
    // },
  },
  created() {
    this.fetchData();
  },
  mounted() {},
  methods: {
    handleClickWd() {
      window.open(
        "https://govern.yaobailian.com:21633/ysfw/upload/药事服务系统介绍.pdf"
      );
    },
    async handleLoginTest(type) {
      this.loginLoading = true;
      let param = {};
      // 连锁总部
      if (type == 1) {
        param = {
          enterpriseId: "838f87dd-9abd-47f1-879d-3e5c8930fee9",
          openId: "oB7_K60vCym_A5DyLIu0TXo46qNg",
        };
      }
      // 连锁总部2
      if (type == 2) {
        param = {
          enterpriseId: "838f87dd-9abd-47f1-879d-3e5c8930fee9",
          openId: "oB7_K603EhXCeqsGvQ4xrOIUfC2A",
        };
      }
      // 连锁门店
      if (type == 0) {
        param = {
          enterpriseId: "c15dd05c-5b37-43f6-9116-fbb7a0e3787b",
          openId: "oB7_K60U20U7_jDDc0INOvDL6Zuw",
        };
      }
      const res = await this.$api.enterprise.TruelyLogin(param);

      this.loginLoading = false;
      clearInterval(this.timer);
      this.$store
        .dispatch("user/login", res.data)
        .then(() => {
          this.$router.push({
            path: "/",
          });
        })
        .catch(() => {});
    },
    async handleLogin() {
      if (this.btnType === 0) return;
      this.loginLoading = true;
      const res = await this.$api.enterprise.TruelyLogin({
        enterpriseId: this.enterpriseId,
        openId: this.openId,
      });
      this.loginLoading = false;
      clearInterval(this.timer);
      this.$store
        .dispatch("user/login", res.data)
        .then(() => {
          this.$router.push({
            path: "/",
            // path: this.redirect || "/",
            // query: this.otherQuery,
          });
        })
        .catch(() => {});
    },
    async fetchData() {
      clearInterval(this.timer);
      this.isExpired = 0;
      this.isScanCode = false;
      this.loading = true;
      // const queryParams = this.$route.query || {};
      // console.log("浏览器传递的参数:", queryParams);
      const res = await this.$api.support.CreateScanQRCode();
      this.loading = false;
      this.codeUrl = res.data.qrCodeImg;
      setTimeout(() => {
        this.isExpired = 2;
        clearInterval(this.timer);
      }, 120000);
      this.timer = setInterval(async () => {
        const beatRes = await this.$api.enterprise.HeartBeatLogin({
          loginKey: res.data.loginKey,
        });
        if (beatRes.data.qrCodeState === 1) {
          this.isExpired = 1;
        }
        if (beatRes.data.success) {
          clearInterval(this.timer);
          if (!beatRes.data.jumpToLogin) {
            // 体验版
            this.enterpriseName = beatRes.data.enterpriseName;
            this.userName = beatRes.data.userName;
            this.userPhone = beatRes.data.userPhone;
            this.userStationStr = beatRes.data.userStationStr;
            this.btnText = beatRes.data.btnText;
            this.btnTextSub = beatRes.data.btnTextSub;
            this.btnType = beatRes.data.btnType;
            this.icon = beatRes.data.icon;
            this.enterpriseId = beatRes.data.enterpriseId;
            this.openId = beatRes.data.openId;
            this.isScanCode = true;
          } else {
            // 正式版
            const TruelyRes = await this.$api.enterprise.TruelyLogin({
              enterpriseId: beatRes.data.enterpriseId,
              openId: beatRes.data.openId,
            });
            this.$store
              .dispatch("user/login", TruelyRes.data)
              .then(() => {
                this.$router.push({
                  path: "/",
                  // path: this.redirect || "/",
                  // query: this.otherQuery,
                });
              })
              .catch(() => {});
          }
        }
      }, 2000);
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    handlePurchase() {
      this.$refs.PurchaseRef.show(this.enterpriseId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
